import React from "react";
import "./InvoiceMessage.css"; // Import the CSS file for styling

const InvoiceMessage = () => {
  return (
    <section className="invoice-message-section">
      <h1 className="invoice-title">Invoice Bill</h1>
      <p className="invoice-subtitle">
        CHECK INVOICE DETAILS & SCAN QR TO PAY THE BILL WITH EASE!
      </p>
      <p className="invoice-description">
        YOU CAN PAY YOUR INVOICE BILL HERE!
      </p>
    </section>
  );
};

export default InvoiceMessage;
